import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from '../../../../shared/components/svg-icon/svg-icon.module';
import { WorkItemEmailListComponent } from './workitem-email-list.component';
import { TooltipModule } from '../../../../shared/components/tooltip/tooltip.module';
import { WorkitemSimpleTimerModule } from 'shared/components/workitem-simple-timer/workitem-simple-timer.module';
import { SkeletonLoaderModule } from 'shared/components/skeleton-loader/skeleton-loader.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild(),
    TooltipModule,
    WorkitemSimpleTimerModule,
    SkeletonLoaderModule
  ],
  declarations: [
    WorkItemEmailListComponent
  ],
  exports: [
    WorkItemEmailListComponent
  ]
})
export class WorkItemEmailListModule {}
